<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :before-close="cancel"
      :title="$t('Gamification_Modify_Fixture')"
      :close-on-click-modal="false"
      @click.native.stop
      top="0"
    >
      <div v-loading="isLoading" data-qa="fixture-form-dialog-wrapper">
        <rest-form
          v-if="model"
          ref="fixture-form-dialog"
          :save-endpoint="saveEndpoint"
          :model="model"
          :after-save="afterSave"
          class="game-fixtures-form"
          @on-error="onError()"
        >
          <form-section :title="$t('Gamification_GameFixturesForm_HomeTeam')">
            <rest-form-item
              prop="participant1_name"
              :label="$t('Gamification_GameFixturesForm_HomeTeamName')"
              class="default-width"
            >
              <el-input v-model="homeTeam" data-qa="input-home-team-name" />
            </rest-form-item>
            <rest-form-item
              prop="home_team_score"
              :label="$t('Gamification_GameFixturesForm_Score')"
              class="default-width"
            >
              <el-input-number
                v-model="homeTeamScore"
                controls-position="right"
                data-qa="input-home-team-score"
                :min="0"
              />
            </rest-form-item>
          </form-section>

          <form-section :title="$t('Gamification_GameFixturesForm_AwayTeam')">
            <rest-form-item
              prop="participant2_name"
              :label="$t('Gamification_GameFixturesForm_AwayTeamName')"
              class="default-width"
            >
              <el-input v-model="awayTeam" data-qa="input-away-team-name" />
            </rest-form-item>
            <rest-form-item
              prop="away_team_score"
              :label="$t('Gamification_GameFixturesForm_Score')"
              class="default-width"
            >
              <el-input-number
                v-model="awayTeamScore"
                controls-position="right"
                data-qa="input-away-team-score"
                :min="0"
              />
            </rest-form-item>
          </form-section>

          <form-section
            :title="$t('Gamification_GameFixturesForm_OverrideFixtureResult')"
          >
            <rest-form-item
              prop="override_result"
              :label="$t('Gamification_GameFixturesForm_OverrideResult')"
            >
              <el-switch
                v-model="canOverrideResult"
                active-color="#1d87c9"
                :active-value="true"
                :inactive-value="false"
                @change="handleOverrideResultChange"
                data-qa="fixture-override-result"
              />
            </rest-form-item>
            <rest-form-item
              prop="fixture_winner"
              :label="$t('Gamification_GameFixturesForm_OverrideResult')"
            >
              <el-radio-group
                v-model="winnerId"
                inline
                data-qa="fixture-winner-radio"
                :disabled="!canOverrideResult"
              >
                <el-radio
                  :label="getHomeTeamId"
                  :data-qa="`fixture-winner-radio-${homeTeam}`"
                  class="fixture-winner-radio"
                >
                  {{ homeTeam }}
                </el-radio>
                <el-radio
                  :label="getAwayTeamId"
                  :data-qa="`fixture-winner-radio-${awayTeam}`"
                  class="fixture-winner-radio"
                >
                  {{ awayTeam }}
                </el-radio>
              </el-radio-group>
            </rest-form-item>
            <rest-form-item
              prop="full_finished"
              :label="$t('Gamification_GameFixturesForm_FullFinished')"
            >
              <el-switch
                v-model="fullFinished"
                active-color="#1d87c9"
                :active-value="1"
                :inactive-value="0"
              />
            </rest-form-item>
          </form-section>
          <!-- TODO: Temporarily hidden, might be needed in the future. -->
          <form-section v-if="false" title="Status">
            <rest-form-item prop="status" label="Status">
              <el-select v-model="getStatus">
                <el-option
                  v-for="status in statusOptions"
                  :key="status.value"
                  :label="$t(status.label)"
                  :value="status.value"
                />
              </el-select>
            </rest-form-item>
          </form-section>
        </rest-form>
      </div>
      <div slot="footer" data-qa="fixture-form-footer">
        <div>
          <el-button
            type="primary"
            @click="cancel"
            plain
            data-qa="fixture-cancel-btn"
          >
            {{ $t('Gamification_Cancel') }}
          </el-button>
          <el-button type="primary" @click="save" data-qa="fixture-save-btn">
            {{ $t('Gamification_GameFixturesForm_UpdateFixture') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm.vue'
import FormSection from '@/common/components/form/FormSection.vue'
import RestFormItem from '@/common/components/rest/RestFormItem.vue'
import { projectEndpoint, customConfirm } from '@/core/helpers'

export default {
  name: 'GameFixtureForm',
  components: { RestFormItem, FormSection, RestForm },
  data() {
    return {
      isLoading: false,
      canOverrideResult: false,
      model: {},
      statusOptions: [
        {
          label: 'Gamification_GameFixturesForm_Status_Pending',
          value: 1
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Inprogress',
          value: 2
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Ended',
          value: 3
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Interrupted',
          value: 4
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Cancelled',
          value: 5
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Walkover',
          value: 6
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Abandoned',
          value: 7
        },
        {
          label: 'Gamification_GameFixturesForm_Status_Retired',
          value: 8
        }
      ]
    }
  },
  props: {
    initialStateModel: {
      type: Object,
      required: true
    },
    dialogVisible: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number,
      required: true
    }
  },

  mounted() {
    this.model = {
      id: this.initialStateModel.id,
      participant1_id: this.initialStateModel.participant1_id || null,
      participant2_id: this.initialStateModel.participant2_id || null,
      participant1_name: this.initialStateModel.participant1.name || null,
      participant2_name: this.initialStateModel.participant2.name || null,
      score1: this.initialStateModel.score1 || 0,
      score2: this.initialStateModel.score2 || 0
    }

    this.canOverrideResult = !!this.initialStateModel.winner_id
  },

  computed: {
    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/fixture/${this.model.id}`
      })
    },
    homeTeam: {
      get() {
        return this.initialStateModel.participant1
          ? this.initialStateModel.participant1.name
          : null
      },
      set(value) {
        this.initialStateModel.participant1.name = value
        this.model.participant1_name = value
      }
    },
    awayTeam: {
      get() {
        return this.initialStateModel.participant2
          ? this.initialStateModel.participant2.name
          : null
      },
      set(value) {
        this.initialStateModel.participant2.name = value
        this.model.participant2_name = value
      }
    },
    homeTeamScore: {
      get() {
        return this.initialStateModel
          ? parseInt(this.initialStateModel.score1)
          : 0
      },
      set(value) {
        this.initialStateModel.score1 = value
        this.model.score1 = value
      }
    },
    awayTeamScore: {
      get() {
        return this.initialStateModel
          ? parseInt(this.initialStateModel.score2)
          : 0
      },
      set(value) {
        this.initialStateModel.score2 = value
        this.model.score2 = value
      }
    },
    getStatus: {
      get() {
        return this.initialStateModel
          ? parseInt(this.initialStateModel.status_id)
          : null
      },
      set(value) {
        this.initialStateModel.status_id = value
        this.model.status_id = value
      }
    },
    fullFinished: {
      get() {
        return this.initialStateModel ? this.initialStateModel.full_finished : 0
      },
      set(value) {
        this.initialStateModel.full_finished = value
        this.model.full_finished = value
      }
    },
    winnerId: {
      get() {
        return this.initialStateModel.winner_id || null
      },
      set(value) {
        this.initialStateModel.winner_id = value
        this.model.winner_id = value
      }
    },
    getHomeTeamId() {
      return this.initialStateModel
        ? this.initialStateModel.participant1_id
        : null
    },
    getAwayTeamId() {
      return this.initialStateModel
        ? this.initialStateModel.participant2_id
        : null
    }
  },

  methods: {
    save() {
      if (this.initialStateModel.full_finished) {
        this.isLoading = true
        this.$refs['fixture-form-dialog'].save()
        return
      }

      customConfirm(
        this.$t('Gamification_GameFixturesForm_FullFinishedPopUp_Title'),
        this.$t('Gamification_GameFixturesForm_FullFinishedPopUp_Description'),
        this.$t('Gamification_GameFixturesForm_FullFinishedPopUp_Continue')
      )
        .then(() => {
          this.isLoading = true
          this.$refs['fixture-form-dialog'].save()
        })
        .finally(() => {
          this.$nextTick(() => {
            const confirmPopUpWrapper = document.querySelector('.v-modal')
            if (confirmPopUpWrapper) {
              confirmPopUpWrapper.remove()
            }
          })
        })
    },
    afterSave(data, finishLoading) {
      finishLoading()
      this.isLoading = false
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    },
    onError() {
      this.isLoading = false
    },
    handleOverrideResultChange(event) {
      if (!event && this.model.winner_id) {
        delete this.model.winner_id
      }
    }
  }
}
</script>

<style scoped>
>>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog__body {
  height: 650px;
  overflow: auto;
}

.fixture-winner-radio {
  display: block;
  margin: 14px 0;
}

.default-width {
  width: 553px;
}

.date-time-ct {
  display: flex;
  gap: 24px;
  align-items: center;
}

.flex-1 {
  flex: 1;
}

@media screen and (max-height: 950px) {
  >>> .el-dialog__body {
    height: 550px;
  }
}

@media screen and (max-height: 850px) {
  >>> .el-dialog__body {
    height: 450px;
  }
}

@media screen and (max-height: 650px) {
  >>> .el-dialog__body {
    height: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/analytics/GameFixturesFormDialog.vue